import React                     from 'react';
import { DefaultItemsPanelView } from './DefaultSettingsView';
import { StyleType }             from '../utility/styles';
import { useCardStyle }          from './UdfEditor';
import SettingsModel             from './SettingsModel';


export const BillingItemsPanelView = ({ settings, refresh, classes }: { settings: SettingsModel, refresh: () => void, classes?: StyleType<typeof useCardStyle> }) => {
  return <DefaultItemsPanelView settings={settings} refresh={refresh} classes={classes} hideAddButton={true} />;
};
